<template>
  <nav class="a-folder-breadcrumb">
    <a
      href="#"
      class="a-folder-breadcrumb__home"
      :title="homeTitle"
      @click.prevent="$emit('goTo', { id: null, index: 0 })"
    >
      <HouseIcon
        :width="16"
        :height="16"
      />
    </a>

    <template v-for="(item, index) in breadcrumbs">
      <span
        :key="`sep-${index}`"
        class="a-folder-breadcrumb__separator"
      >/</span>
      <a
        :key="item.id"
        href="#"
        class="a-folder-breadcrumb__link"
        :title="item.text"
        @click.prevent="go(item.id, index + 1)"
      >{{ item.text }}</a>
    </template>
  </nav>
</template>

<script>
import { House as HouseIcon } from 'lucide-vue';

export default {
  name: 'FolderBreadcrumb',
  components: { HouseIcon },
  props: {
    // `[{ id, text }]`, root first.
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    homeTitle: {
      type: String,
      default: 'Home',
    },
  },
  methods: {
    go(id, index) {
      if (index === this.breadcrumbs.length) {
        return;
      }

      this.$emit('goTo', { id, index });
    },
  },
};
</script>

<style scoped lang="scss">
.a-folder-breadcrumb {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  font-size: 14px;
  color: #727272;
}

.a-folder-breadcrumb__home {
  display: inline-flex;
  flex: 0 0 auto;
  color: #727272;
  margin-bottom: 4px;

  &:hover {
    color: rgb(34, 38, 42);
  }
}

.a-folder-breadcrumb__separator {
  flex: 0 0 auto;
}

.a-folder-breadcrumb__link {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #209c86;
  text-decoration: none;

  &:hover {
    color: #209c86;
    text-decoration: underline;
  }
}
</style>
